var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-card',[_c('b-row',[_c('b-col',[_c('app-people-evaluated-filters',{on:{"filter":_vm.onFilter}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('app-people-evaluated-list',{attrs:{"on-change-page":_vm.onChangePage,"table-data":_vm.peopleEvaluated}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }